import "./questions.scss";
const Questions = () => {
  return (
    <div className="question-box">
      <div>
        <h1>Frequently asked questions</h1>
      </div>
      <div className="row question">
        <div className="col-lg-5 col-sm-10 question-content">
          <h6> Does a donor have to contribute every month?</h6>
          <p>
            Yes & No. If you could, you can else there's an option of donating in Lumpsum way too.  Once in every quarter, every 6 months, annually or on any of your special occasions like birthday, promotion day, anniversaries, or in memory of loved ones.
          </p>
        </div>
        <div className=" col-lg-5 col-sm-10 question-content">
          <h6>How can I be sure my donation is used for the mentioned?</h6>
          <p>
            This initiative runs on trust, but it’s a fair question. To ensure transparency, we have shared our accountant’s contact number on our website for verification. Additionally, we provide an 80G certificate to every donor before the IT filing period
          </p>
        </div>
      </div>
      <div className="row question">
        <div className="col-lg-5 col-sm-10  question-content">
          <h6> Is it possible for a donor to see your work in person?</h6>
          <p>
            100% yes. In fact, you could spend time with our on-the-ground volunteers who distribute food every night between 8pm-9pm, if you are in Thanjavur
          </p>
        </div>
        <div className=" col-lg-5 col-sm-10  question-content">
          <h6> What is the long term plan & current work of Pagirundhunn?</h6>
          <p>
            Currently we are distributing tiffins daily to the needy and destitute since Dec 2022. We are also stepping into the field of  education. As a first step we have already supported 4 government school students entering 10th standard by covering all their academic expenses.
          </p>
        </div>
      </div>
      <div className="row question">
        <div className="col-lg-5 col-sm-10  question-content">
          <h6>Do you accept donations outside India?</h6>
          <p>
            Yes, we do. Donors outside India can transfer directly to our trust’s bank account. We already have a few international contributors supporting our cause. Please ensure that the transfer is made in Indian Rupees (INR)
          </p>
        </div>
        <div className=" col-lg-5 col-sm-10  question-content">
          <h6>How can I donate?</h6>
          <p>
            You can donate through our website by choosing a one-time or monthly
            contribution. We also accept UPI, bank transfers, and other payment
            methods.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Questions;
